module.exports = __webpack_public_path__ + "static/img/logo_black-removebg-preview.0941a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_black-removebg-preview.png
// module id = No/f
// module chunks = 13